import useAuth from 'hooks/useAuth';
import { useQuery } from 'react-query';
import { ComplimentaryCount } from 'types/complimentary';
import { User } from 'types/user';

export default function useComplementryTherapists() {
  const { request, userId } = useAuth();

  const { data: therapists, isLoading: therapistsLoading } = useQuery(
    'contactus/complementry_therapist',
    () => request.get('/contactus/complementry_therapist').then((response) => response.data.userTherapistData as User[]),
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false
    }
  );

  const { data: getContactCount, refetch: refetchUserContact } = useQuery(
    `/contactus/complimentry-count`,
    () => request.get(`/contactus/complimentry-count?therapistId=${userId}`).then(({ data }) => data as ComplimentaryCount),
    {
      enabled: !!userId
    }
  );

  return { therapists, therapistsLoading, getContactCount, refetchUserContact };
}
